import { render } from "./EditorComp.vue?vue&type=template&id=413002f7"
import script from "./EditorComp.vue?vue&type=script&lang=js"
export * from "./EditorComp.vue?vue&type=script&lang=js"

import "./EditorComp.vue?vue&type=style&index=0&id=413002f7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__